import { render } from "./kanban.vue?vue&type=template&id=2347165e"
import script from "./kanban.vue?vue&type=script&lang=ts"
export * from "./kanban.vue?vue&type=script&lang=ts"

import "./kanban.vue?vue&type=style&index=0&id=2347165e&lang=css"
script.render = render

export default script